import Loading from "../../components/Loading";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {getRatingFactor} from "../../api/routes";
import queryString from "../../functions/queryString";
import {toast} from "react-toastify";
import RatingFactorTable from "./RatingFactorTable";
import InfiniteScroll from "react-infinite-scroll-component";

export default function RatingFactor() {
    const [searchParams] = useSearchParams()

    const [loading, setLoading] = useState(false);
    const [cursor, setCursor] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [ratingFactor, setRatingFactor] = useState([]);
    const [trigger, setTrigger] = useState(null);

    useEffect(() => {
        setLoading(true);
        const query = {
            cursor: cursor === null ? null : cursor,
        }
        getRatingFactor(queryString(query), trigger !== null, (isOk, data) => {
            setLoading(false);
            if (!isOk) {
                return toast.error(data.message)
            } else {
                if (page !== 0) {
                    setRatingFactor((prev) => ([...prev, ...data.data]));
                } else {
                    setRatingFactor(data.data);
                }
                setCursor(data.meta.next_cursor === null ? '' : data.meta.next_cursor);
                if (data.meta.next_cursor !== null)
                    return setHasMore(true);

                else return setHasMore(false)
            }
        })
    }, [page, trigger]);

    useEffect(() => {
        if (searchParams.get("update")) {
            if (page === 0)
                setTrigger(Math.random());
            else
                setPage(0);

            setCursor(null);
        }
    }, [searchParams.get("update")]);

    const fetchMoreData = () => {
        if (loading) return;
        if (hasMore) {
            setPage(prevPage => prevPage + 1)
        }
    }
    return (
        <DashboardLayout>
            <Loading loading={loading}/>
            <DashboardNavbar/>
            <InfiniteScroll dataLength={ratingFactor.length} next={fetchMoreData} hasMore={hasMore}>
                <RatingFactorTable data={ratingFactor}/>
            </InfiniteScroll>
        </DashboardLayout>
    )
}
